import { pdfContent } from './mock/fakePdf'

const exportPdf = async () => {
  const blob = new Blob([pdfContent], { type: 'application/pdf' })

  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = `relatorio-inventario-${new Date().toISOString().split('T')[0]}.pdf`

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 100)
}

export { exportPdf }
